import styles from './QuoteLight.module.css'

interface QuoteLightProps {
  text: string
  author: string
}

export default function QuoteLight({ text, author }: QuoteLightProps) {
  return (
    <blockquote className={styles.block} data-testid="quote-light">
      <div className={styles.mark}>&ldquo;</div>
      <div className={styles.text}>{text}</div>
      <div className={styles.author}>&mdash; {author}</div>
    </blockquote>
  )
}
